module.exports = __webpack_public_path__ + "img/empty-cart.fc1f129.png";